import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import pickBy from 'lodash/pickBy'
import mapKeys from 'lodash/mapKeys'
import startsWith from 'lodash/startsWith'
import zipObject from 'lodash/zipObject'

const NON_AMAZON_URLS = {
  'Shape Up': 'https://basecamp.com/shapeup',
}

function useBooks() {
  const [data, setData] = useState([])
  const [status, setStatus] = useState('IDLE')

  function getUrl() {
    const id = '1asYiRqR9QHz9hgR9mp1VK61aQomE96gUUAfZhdNlda0'
    return `https://spreadsheets.google.com/feeds/list/${id}/1/public/values?alt=json`
  }

  function getBookLink(id) {
    return id ? `http://www.amazon.com/gp/product/${id}` : ''
  }

  function normalizeData(data) {
    const filteredData = data.map(d => {
      return pickBy(d, (value, key) => {
        return startsWith(key, 'gsx$')
      })
    })

    const normalizedData = filteredData.map(fd => {
      const filteredKeys = mapKeys(fd, (value, key) => key.split('$').pop())
      const keys = Object.keys(filteredKeys)
      const values = Object.keys(fd).map(key => fd[key].$t)

      return zipObject(keys, values)
    })

    const refinedData = normalizedData.map(nd => ({
      ...nd,
      url: NON_AMAZON_URLS[nd.title]
        ? NON_AMAZON_URLS[nd.title]
        : getBookLink(nd.id),
    }))

    setData(refinedData)
    setStatus('COMPLETE')
  }

  useEffect(() => {
    async function get() {
      setStatus('LOADING')
      const response = await fetch(getUrl())
      const results = await response.json()
      const data = results.feed.entry
      normalizeData(data)
    }

    if (data.length === 0) get()
  }, [setStatus])

  return { books: data, status }
}

export default useBooks
